import type { IconNode } from '../types';

/**
 * @name vest
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgNGEyIDIgMCAwIDAgNCAwVjNoNHYzYzAgMS43IDEuMyAzIDMgM3YxMGEyIDIgMCAwIDEtMiAySDVhMiAyIDAgMCAxLTItMlY5YzEuNyAwIDMtMS4zIDMtM1YzaDRaIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/vest
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const vest: IconNode = [
  [
    'path',
    {
      d: 'M10 4a2 2 0 0 0 4 0V3h4v3c0 1.7 1.3 3 3 3v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9c1.7 0 3-1.3 3-3V3h4Z',
      key: '1aiibo',
    },
  ],
];

export default vest;
